// ======================================================================
// ERPFilterBar.jsx
// Standard ERP Report Toolbar
// ======================================================================

import React from "react";
import "./reportStyles.css";

/*
USAGE:

<ERPFilterBar
   left={ <> filters here </> }
   right={ <> totals / buttons </> }
/>
*/

export default function ERPFilterBar({ left, right }) {

  return (
    <div className="erp-filterbar">

      {/* LEFT SIDE (filters) */}
      <div className="erp-filter-left">
        {left}
      </div>

      {/* RIGHT SIDE (actions / KPIs) */}
      <div className="erp-filter-right">
        {right}
      </div>

    </div>
  );
}
